import {
  LayoutDashboard,
  Phone,
  Users,
  ListOrdered,
  Hash,
  MessageSquare,
  Mail,
  Network,
  PhoneCall,
  Route,
  Server,
  Boxes,
  Key,
  CreditCard,
  Receipt,
  Megaphone,
  PhoneOutgoing,
  MapPin,
  Video,
  Mic,
  FileText,
  Bot,
  Sparkles,
  MessageCircle,
  Tag,
  Settings,
  BarChart3,
  Shield,
} from 'lucide-react'

// Map icon names to Lucide components
export const iconMap = {
  // Lucide icon names (used in new navigation)
  Phone: Phone,
  MessageSquare: MessageSquare,
  Bot: Bot,
  Settings: Settings,
  BarChart3: BarChart3,
  Shield: Shield,
  LayoutDashboard: LayoutDashboard,
  Users: Users,
  Mail: Mail,
  MessageCircle: MessageCircle,
  Tag: Tag,

  // CoreUI icon names (legacy support)
  cilSpeedometer: LayoutDashboard,
  cilPhone: Phone,
  cilSmile: Users,
  cilEqualizer: ListOrdered,
  cilDialpad: Hash,
  cilChatBubble: MessageSquare,
  cibGmail: Mail,
  cilRouter: Network,
  cilFork: PhoneCall,
  cilHandPointRight: Route,
  cilLocomotive: Server,
  cilGroup: Boxes,
  cilLockUnlocked: Key,
  cilDollar: CreditCard,
  cilBook: Receipt,
  cilVideogame: Megaphone,
  cilListRich: PhoneOutgoing,
  cilMap: MapPin,
  cilCommentSquare: MessageSquare,
  cilMediaPlay: Mic,
  cilFont: FileText,
  cilSpreadsheet: Bot,
  cilLoopCircular: Sparkles,
  cilCommentBubble: MessageCircle,
  cilPaperclip: Tag,
}

export const getIcon = (iconName) => iconMap[iconName] || LayoutDashboard
